export enum Permission {
  BASIC_ACCESS = "basic_access",
  RTRACKER_REPORT_ADD_OWN = "rtracker_report_add_own",
  RTRACKER_REPORT_DISABLE_ALL = "rtracker_report_disable_all",
  RTRACKER_REPORT_DISABLE_OWN = "rtracker_report_disable_own",
  RTRACKER_REPORT_VIEW_OWN = "rtracker_report_view_own",
  RTRACKER_REPORT_VIEW_ONLY = "view_reporttracker",
  RTRACKER_REPORT_CHANGE_OWN = "rtracker_report_change_own",
  RTRACKER_REPORT_ASSIGN_OWN = "rtracker_report_assign_own",
  RTRACKER_REPORT_ASSIGN_ALL = "rtracker_report_assign_all",
  RTRACKER_OPTS_CONFIG_DEFAULT_MESSAGES_VIEW = "rtracker_opts_config_default_messages_view",
  RTRACKER_OPTS_CONFIG_DEFAULT_MESSAGES_CHANGE = "rtracker_opts_config_default_messages_change",
  RTRACKER_OPTS_COUNTRY_OVERVIEW_VIEW = "rtracker_opts_country_overview_view",
  RTRACKER_OPTS_COUNTRY_OVERVIEW_CHANGE = "rtracker_opts_country_overview_change",
  NOTIF_RTRACKER_ALL = "notif_rtracker_all",
  NOTIF_RTRACKER_OWN = "notif_rtracker_own",
  NOTIF_KDB_OWN_CUSTOMERS = "notif_kdb_own_customers",
  NOTIF_KDB_ALL = "notif_kdb_all",
  CUSTOMER_PROFILE_CHANGE_CAM = "customer_profile_change_cam",
  CUSTOMER_PROFILE_DISABLE = "customer_profile_disable",
  CUSTOMER_VIEW_ONLY = "view_customer",
  WORKFLOW_KDB_APPROVE_ALL = "workflow_kdb_approve_all",
  WORKFLOW_KDB_APPROVE_CAM = "workflow_kdb_approve_cam",
  ACCOUNT_VIEW_ONLY = "view_account"
}
